// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1cLyK","title":"Info_title__3oXRq","links":"Info_links__26LKj","link":"Info_link__jtTHz","logo":"Info_logo__3CjXQ"};